var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_14949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18701 30.5133L2.18701 40.4575H12.677V30.5133H2.18701Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68701 13.6527H12.177C12.3096 13.6527 12.4368 13.7087 12.5306 13.8083C12.6243 13.9079 12.677 14.043 12.677 14.1839V29.8227H2.18701V14.1839C2.18701 14.043 2.23969 13.9079 2.33346 13.8083C2.42723 13.7087 2.5544 13.6527 2.68701 13.6527V13.6527Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.067 10.7098H25.557C25.6896 10.7098 25.8168 10.7658 25.9106 10.8654C26.0043 10.965 26.057 11.1002 26.057 11.241V21.4615H15.567V11.241C15.567 11.1002 15.6197 10.965 15.7135 10.8654C15.8072 10.7658 15.9344 10.7098 16.067 10.7098Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.567 22.2264L15.567 40.4575H26.057V22.2264H15.567Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.937 17.2437V40.4575H39.427V17.2437H28.937Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.437 0.733765H38.927C39.0596 0.733765 39.1868 0.789731 39.2806 0.889352C39.3743 0.988973 39.427 1.12409 39.427 1.26497V16.4257H28.937V1.26497C28.937 1.12409 28.9897 0.988973 29.0835 0.889352C29.1772 0.789731 29.3044 0.733765 29.437 0.733765V0.733765Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.807007 40.4576L40.807 40.3195",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_14949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.807007 0.733765)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedColumn);
export default __webpack_public_path__ + "static/media/stacked_column.ab248da11ddc2301c94562353af63e54.svg";
export { ForwardRef as ReactComponent };